import { observer } from 'mobx-react-lite'
import { useUnifiedAgentContext } from 'pages/chatbot/ui/UnifiedAgent/context/unifiedAgentContext'
import { InstructionsSectionContent } from './InstructionsSectionContent'

export const InstructionsSection = observer(() => {
  const { instructionsSectionStore } = useUnifiedAgentContext()

  return (
    <InstructionsSectionContent
      store={instructionsSectionStore}
      isExpanded={false}
      onOpenModal={instructionsSectionStore.openModal}
    />
  )
})
